import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { Notes } from '@mui/icons-material';

interface CallNotesSectionProps {
  notes: string;
}

export const CallNotesSection: React.FC<CallNotesSectionProps> = ({ notes }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: 1.5,
        borderLeft: '4px solid #3b82f6'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 1.5 }}>
        <Notes sx={{ color: '#3b82f6', fontSize: 20, mt: 0.25 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Call Notes
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: '#374151',
          lineHeight: 1.6,
          whiteSpace: 'pre-wrap',
          ml: 4
        }}
      >
        {notes}
      </Typography>
    </Paper>
  );
};
